import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../http";

export type ModelCoefficients = {
  WRITING_ANALYSIS: number;
  AI_DETECTION: number;
  QUILLBOT_ANALYSIS: number;
  SOURCE_DETECTION: number;
  AI_DETECTION_HIGHLIGHTER: number;
  PLAGIARISM: number;
  REWRITE: number;
  SUMMARIZE: number;
  EXPAND: number;
  SHORTEN: number;
  ADD_CONTENT: number;
  HUMANIZER: number;
  PII_TEXT_DETECT: number;
};

async function getModelCoefficients() {
  return await api.detector.get<ModelCoefficients>(
    "ai-detector/model-coefficient-values",
  );
}

export const modelCoefficientsQueryOptions = queryOptions({
  queryKey: ["modelCoefficients"],
  async queryFn() {
    const res = await getModelCoefficients();
    const data = await res.json();
    return { res, data };
  },
  select({ data }) {
    return data;
  },
});

export function useModelCoefficients() {
  return useQuery(modelCoefficientsQueryOptions);
}
